import historyProvider from './historyProvider'
import dataProvider from './dataProvider'
import localDBProvider from './localDBProvider'

const supportedResolutions = ['1D', '1W', '1M', '3M', '12M']; //, "W", "M"];//["1", "3", "5", "15", "30", "60", "120", "240", "D"]

const lastBarsCache = new Map();

// const config = {
	
// 	// Represents the resolutions for bars supported by your datafeed
//     supported_resolutions: supportedResolutions,
// 	supports_search: true,
//     // The `exchanges` arguments are used for the `searchSymbols` method if a user selects the exchange
//     exchanges: [
//         { value: 'Bitfinex', name: 'Bitfinex', desc: 'Bitfinex'},
//         { value: 'Kraken', name: 'Kraken', desc: 'Kraken bitcoin exchange'},
//     ],
	
//     // The `symbols_types` arguments are used for the `searchSymbols` method if a user selects this symbol type
//     symbols_types: [
//         { name: 'crypto', value: 'crypto'}
//     ]
// }; 

const config = {
    supports_search: true,
    supports_group_request: false,
    supports_marks: true,
    supports_timescale_marks: true,
    supports_time: true,
    exchanges: [
        { value: "", name: "All Exchanges", desc: "" },
        //{ value: "NasdaqNM", name: "NasdaqNM", desc: "NasdaqNM" },
        //{ value: "NYSE", name: "NYSE", desc: "NYSE" }
    ],
    symbols_types: [
        { name: "All types", value: "" },
        // { name: "Stock", value: "stock" },
        // { name: "Index", value: "index" },
		// { name: 'crypto', value: 'crypto'}
    ],
    supported_resolutions: ["1D", "1W", "1M", "3M", '12M']
}

export default {
	onReady: (callback) => {
		console.log('===== [onReady]: Method call')	
		setTimeout(() => callback(config))		
	},

	searchSymbols: async (
		userInput, 
		exchange, 
		symbolType, 
		onResultReadyCallback
	) => {
		console.log('====Search Symbols running');
		await localDBProvider.getSymbols(userInput)
		.then(dataInfo => {
			if (dataInfo.length) {
				onResultReadyCallback(dataInfo, {noData: false})
			} else {
				onResultReadyCallback(dataInfo, {noData: true})
			}
		}).catch(err => {
			console.log('erroreeee-->' + {err});
			//console.log('debug errore: ' + dataInfo);
			//onErrorCallback(err)
		})

	},
	resolveSymbol: async (
		symbolName, 
		onSymbolResolvedCallback, 
		onResolveErrorCallback, 
		extension
	) => {
		// expects a symbolInfo object in response
		console.log('======resolveSymbol running')
		// console.log('resolveSymbol:',{symbolName})
		//var split_data = symbolName.split(/[:/]/)
		// console.log({split_data})
		console.log('<<<<<debug: ' + symbolName);
		/*
		const symbolItem = symbols.find(({
			full_name,
		}) => full_name === symbolName);
		if (!symbolItem) {
			console.log('[resolveSymbol]: Cannot resolve symbol', symbolName);
			onResolveErrorCallback('cannot resolve symbol');
			return;
		}	
		*/	
		var symbolInfo = {
			ticker: symbolName,
			name: symbolName,
			description: '',
			type: 'index',
			session: '24x7',//'0900-1730|0900-1730:2',//'24x7',
			timezone: 'Etc/UTC',
			exchange: '',
			minmov: 1,
			pricescale: 1000,  //determina il numero di decimali e la scala dei valori
			has_intraday: false,
			has_no_volume: false,
			has_weekly_and_monthly: false,
			has_ticks: false,
			has_seconds: false,
			monthly_multipliers: "3",
			has_daily: true,
			//intraday_multipliers: ["D"], //['1', '60'],
			supported_resolution:  supportedResolutions,
			volume_precision: 2,
			data_status: 'streaming',
		};
		/*
		if (split_data[2].match(/USD|EUR|JPY|AUD|GBP|KRW|CNY/)) {
			symbolInfo.pricescale = 100
		}*/
		/*
		setTimeout(function() {
			onSymbolResolvedCallback(symbolInfo)
			console.log('Resolving that symbol....', symbolInfo)
		}, 0)
		*/
		console.log('[resolveSymbol]: Symbol resolved', symbolName);
		onSymbolResolvedCallback(symbolInfo);
		// onResolveErrorCallback('Not feeling it today')

	},

	getBars: async function(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
		const { from, to, firstDataRequest } = periodParams;
		console.log('[getBars]: Method call', symbolInfo, resolution, from, to);
		//const dateFrom = new Date(from);
		//const dateTo = new Date(to);
		//console.log('=====getBars running, requested:', symbolInfo, resolution, dateFrom, dateTo);
		//console.log('=====getBars-periodParams.firstDataRequest=', periodParams.firstDataRequest);
		//console.log('=====getBars-periodParams.countBack=', periodParams.countBack);
		// console.log('function args',arguments)
		// console.log(`Requesting bars between ${new Date(from * 1000).toISOString()} and ${new Date(to * 1000).toISOString()}`)
		//historyProvider.getBars(symbolInfo, resolution, from, to, firstDataRequest)
		//dataProvider.getBars(symbolInfo, resolution, from, to, firstDataRequest)
		localDBProvider.getBars(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback)
		.then(bars => {
			if (firstDataRequest) {
                lastBarsCache.set(`${symbolInfo.exchange}:${symbolInfo.name}`, { ...bars[bars.length - 1] });
			}			

			//console.log(`[getBars]: returned ${bars.length} bar(s)`);

		}).catch(err => {
			//console.log('[getBars]: Get error', err);
			//onErrorCallback(err)
		});

	},
	subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
		console.log('=====[subscribeBars]: Method call with subscriberUID:', subscriberUID);
	},
	unsubscribeBars: subscriberUID => {
		console.log('=====[unsubscribeBars]: Method call with subscriberUID:', subscriberUID);
	},
	calculateHistoryDepth: (resolution, resolutionBack, intervalBack) => {
		//optional
		console.log('=====calculateHistoryDepth running');
		// while optional, this makes sure we request 24 hours of minute data at a time
		// CryptoCompare's minute data endpoint will throw an error if we request data beyond 7 days in the past, and return no data
		return resolution < 60 ? {resolutionBack: 'D', intervalBack: '1'} : undefined
	},
	getMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
		//optional
		console.log('=====getMarks running')
	},
	getTimeScaleMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
		//optional
		console.log('=====getTimeScaleMarks running')
	},
	getServerTime: cb => {
		console.log('=====getServerTime running')
	},

};